import {inject, singleton} from "tsyringe";
import {ICalEvent} from "../domain/dtos/i-cal-event.dto";
import {Project} from "../domain/entities/project.entity";
import {ProjectTypeRepository} from "../domain/repositories/project-type.repository";
import {ArrayHelper} from "../helpers/array.helper";
import {AbstractIcalToEntityTransformer} from "./abstract-ical-to-entity.transformer";

@singleton()
export class ICalToProjectTransformer extends AbstractIcalToEntityTransformer<Project | null> {

    private keyMapping = new Map<string, string>([
        ['other', 'external-event'],
        ['project', 'project']
    ])

    constructor(
        @inject(ProjectTypeRepository) private readonly projectTypeRepository: ProjectTypeRepository,
    ) {
        super();
    }

    public async transform(iCalEvent: ICalEvent): Promise<Project | null> {
        const category = ArrayHelper.first<string>(iCalEvent.categories);
        if (!category) {
            return null;
        }

        const projectType = await this.projectTypeRepository.findOneByKey(this.keyMapping.get(category.toLocaleLowerCase())!);

        const project = new Project(projectType);

        project.title = iCalEvent
            .summary
            .trim()
            .replace(/³/g, '').replace(/\W{2,}/g, ' ');

        project.url = iCalEvent.url ?? null;
        if (iCalEvent.organizer) {
            const creator = await this._getCreator(iCalEvent.organizer);
            if (creator) {
                project.creator = creator;
            }
        }

        if (iCalEvent.attendee) {
            project.employees = await this._getEmployees(iCalEvent.attendee);
        }

        return project;
    }

    // protected async _convertToIssue(iCalEvent: ICalEvent, assignees: Map<string, Project>): Promise<Issue> {
    //
    //     const start = DateTime.fromJSDate(iCalEvent.start).startOf(`day`);
    //     const end = DateTime.fromJSDate(iCalEvent.end).startOf(`day`);
    //
    //     const projectKey = ICCalToProjectTransformer._getTitle(iCalEvent).toLocaleLowerCase();
    //     if (!assignees.has(projectKey)) {
    //         console.error(`No project found for "${iCalEvent.summary}" with key "${projectKey}"`);
    //     }
    //
    //     const issue = new Issue(assignees.get(projectKey)!);
    //
    //     issue.uid = UuidHelper.generateV4();
    //     issue.interval = Interval.fromDateTimes(start, end);
    //     issue.status = await this._findIssueStatus(iCalEvent);
    //     issue.employees = await this._getEmployees(iCalEvent.attendee);
    //     issue.description = iCalEvent.description || '' // das || '' bedeutet, wenn keine Beschreibung, dann leere Zeichenkette
    //     issue.type = await this._findIssueType(iCalEvent)
    //
    //     return issue;
    // }

    // private async _getEmployees(attendee: ConfluenceUser | ConfluenceUser[]): Promise<Employee[]> {
    //
    //     if (!Array.isArray(attendee)) {
    //         attendee = [attendee].filter(a => !!a);
    //     }
    //
    //     return (await Promise.all(attendee.map((attendee: ConfluenceUser) => {
    //         const [lastName, firstName] = String(JSON.parse(attendee.params?.CN || ''))
    //             .toString()
    //             .split(`,`)
    //             .map(t => t.trim());
    //
    //         return this.employeeRepository.findOneByFullName(lastName, firstName);
    //     }))).filter((employee): employee is Employee => !!employee);
    //
    // }

    // private static _getTitle(iCalEvent: ICalEvent): string {
    //     let [title] = iCalEvent.summary.split(':').map(v => v.trim());
    //     let pos = title.lastIndexOf(' ');
    //     if (pos < 0) {
    //         pos = title.length;
    //     }
    //
    //     return title.substring(0, pos).replace(/\W{2,}/g, ' ').trim();
    // }

    // private async _findIssueStatus(iCalEvent: ICalEvent): Promise<IssueStatus | null> {
    //     const statusOfICal = (iCalEvent.location || '').trim().toLocaleLowerCase();
    //
    //     switch (statusOfICal) {
    //         case `offen`:
    //             return this.issueStatusRepository.findOneBy(`key`, `OPEN`);
    //         case `erledigt`:
    //             return this.issueStatusRepository.findOneBy(`key`, `DONE`);
    //     }
    //
    //     return null;
    // }
}